import { useState, useEffect, useRef } from 'react'
import '../style/chat.scss'
import {
  createChatThread,
  deleteChatThread,
  getAllChatThreads,
  getChatsFromThread,
  updateChatThreadTitle,
} from '../core/_requests'
import React from 'react'
import { toast } from 'react-toastify'
import { useAuth } from '../../auth'
import { useIntl } from 'react-intl'
import AddChaticon from '../../../../media/AI-banker/ic-add-chat.svg'
import Chaticon from '../../../../media/AI-banker/ic-chat.svg'
import Sendicon from '../../../../media/AI-banker/ic-send.svg'
import AIGenericImage from '../../../../media/AI-banker/ai-generic-image.png'
import TypingAnimation from '../components/typing-animation'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { AIBankerQuestions } from '../core/_constants'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useDateFormat } from '../../../hooks/useDateFormat'
import { useTimeZone } from '../../../hooks/useTimeZone'
import { DateTime } from 'luxon'
import ReactMarkdown from 'react-markdown'
import { Dropdown } from 'react-bootstrap'
import { DeleteConfirmationModal } from '../components/DeleteConfirmationModal'
import ThreadTitle from '../components/shortenString'
import { SideAIChatMenu } from '../components/sideChatMenu'
import Skeleton from 'react-loading-skeleton'
import { useThemeMode } from '../../../../_metronic/partials'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { errorMessage } from '../../profile/core/_constants'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { removeNullFields } from '../../../core/_util'

export const AIBankerView = () => {
  const [selectedConversation, setSelectedConversation] = useState<string | null>(null)
  const [isBotTyping, setIsBotTyping] = useState<boolean>(false)
  const { currentUser, companyId, isShowHelpBanners, setShowBillingModal } = useAuth()
  const { formatMessage } = useIntl()
  const [chatThreads, setChatThreads] = useState<any[]>([])
  const [chatsFromThread, setChatsFromThread] = useState<any[]>([])
  const [userInput, setUserInput] = useState('')
  const [isNewConversation, setIsNewConversation] = useState<boolean>(true)
  const [threadId, setThreadId] = useState<string>()
  const [promptText, setPromptText] = useState<string>()
  const [response, setResponse] = useState<any>()
  const [buttonIndex, setButtonIndex] = useState<number>(-1)
  const { getDateValue } = useDateFormat()
  const { getTimeZoneValue } = useTimeZone()
  const [isMessageSend, setIsMessageSend] = useState<boolean>(false)
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const [showThread, setShowThread] = useState<string>()
  const [newTitle, setNewTitle] = useState<string>('')
  const [editingThreadId, setEditingThreadId] = useState<string | null>(null)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)
  const [isRenaming, setIsRenaming] = useState<boolean>(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isloading, setLoading] = useState<boolean>(true)
  const [isTitleRenaming, setIsTitleRenaming] = useState<boolean>(false)
  const [editThreadId, setEditThreadId] = useState<string | null>(null)
  const [error, setError] = useState('')

  const { mode } = useThemeMode()

  useEffect(() => {
    // Set up a timeout to change the loading state after 2 seconds (2000 milliseconds)
    const timer = setTimeout(() => {
      setLoading(false)
    }, 4000) // Adjust the delay as needed

    // Cleanup function to clear the timeout if the component unmounts
    return () => clearTimeout(timer)
  }, [])
  const handleInputChange = (e: any) => {
    const input = e.target.value

    // Check if input exceeds 2000 characters
    if (input.length > 2000) {
      setError('Message limit is 2000 characters')
    } else {
      setError('')
      setUserInput(input)
    }
  }
  // Fetch all chat threads
  const getAllThreads = async () => {
    try {
      const {
        data: { success, data },
      } = await getAllChatThreads(companyId)
      if (success) {
        setChatThreads(data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setIsRenaming(false)
      setIsTitleRenaming(false)
      setEditingThreadId(null)
      setEditThreadId(null)
    }
  }

  useEffect(() => {
    getAllThreads()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Fetch all chat threads
  const getAllChatsFromThread = async () => {
    try {
      const {
        data: { success, data },
      } = await getChatsFromThread(threadId, companyId)
      if (success) {
        setChatsFromThread(data.reverse())
        setResponse('')
        setPromptText('')
        setIsNewConversation(false)
        setButtonIndex(-1)
        handleSelectConversation(data[0].chatThreadId)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setIsBotTyping(false)
    }
  }
  useEffect(() => {
    if (threadId) {
      getAllChatsFromThread()
    }
  }, [threadId]) // eslint-disable-line react-hooks/exhaustive-deps

  // Handle selecting a conversation
  const handleSelectConversation = (index: string) => {
    setSelectedConversation(index)
  }

  const groupThreadsByDate = (threads: any[]) => {
    const grouped: { [key: string]: any[] } = {}
    const now = DateTime.now()

    threads.forEach((thread) => {
      const threadDate = DateTime.fromISO(thread.lastMessageAt)

      // Calculate difference
      const diffInDays = Math.floor(now.diff(threadDate, 'days').days)

      // Determine the group key
      let groupKey = ''

      if (threadDate.hasSame(now, 'day')) {
        groupKey = 'Today'
      } else if (threadDate.hasSame(now.minus({ days: 1 }), 'day')) {
        groupKey = 'Yesterday'
      } else if (diffInDays <= 7) {
        groupKey = `${diffInDays} days ago`
      } else {
        // Handle dates older than 7 days
        const diffInMonths = Math.floor(now.diff(threadDate, 'months').months)
        if (diffInMonths < 12) {
          groupKey = `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`
        } else {
          const diffInYears = Math.floor(now.diff(threadDate, 'years').years)
          groupKey = `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`
        }
      }

      // Initialize group if not already
      if (!grouped[groupKey]) {
        grouped[groupKey] = []
      }

      // Add thread to the appropriate group
      grouped[groupKey].push(thread)
    })

    return grouped
  }

  const sortedDates = (groupedThreads: { [key: string]: any[] }) => {
    const dateOrder: { [key: string]: number } = {
      Today: 0,
      Yesterday: 1,
    }

    return Object.keys(groupedThreads).sort((a, b) => {
      const aOrder = dateOrder[a] !== undefined ? dateOrder[a] : Infinity
      const bOrder = dateOrder[b] !== undefined ? dateOrder[b] : Infinity

      // Sort "Today" and "Yesterday" first
      if (aOrder !== Infinity || bOrder !== Infinity) {
        return aOrder - bOrder
      }

      // Function to parse date key
      const parseDateKey = (key: string): DateTime => {
        const dateParts = key.split(' ')

        if (dateParts.length === 3) {
          // e.g., "4 days ago"
          const daysAgo = parseInt(dateParts[0], 10)
          return DateTime.now().minus({ days: daysAgo })
        } else if (dateParts.length === 4) {
          // e.g., "2 months ago" or "1 year ago"
          const value = parseInt(dateParts[0], 10)
          const unit = dateParts[1]
          if (unit === 'month' || unit === 'months') {
            return DateTime.now().minus({ months: value })
          } else if (unit === 'year' || unit === 'years') {
            return DateTime.now().minus({ years: value })
          }
        }
        // Handle unexpected cases by assuming the format is incorrect
        return DateTime.now() // Default to now
      }

      const aDate = parseDateKey(a)
      const bDate = parseDateKey(b)

      return bDate.toMillis() - aDate.toMillis()
    })
  }

  const groupedThreads = groupThreadsByDate(chatThreads)
  const sortedThreadDates = sortedDates(groupedThreads)

  console.log(sortedThreadDates, ' sortedThreadDates')
  console.log(groupedThreads, ' groupedThreads')

  const chatSend = async () => {
    setIsMessageSend(true)
    setPromptText(userInput)
    setIsBotTyping(true)
    try {
      if (companyId) {
        let payload: any
        if (isNewConversation) {
          payload = {
            prompt: userInput,
          }
        } else {
          payload = {
            prompt: userInput,
            chatThreadId: threadId,
          }
        }
        console.log(payload, ' payload')
        setUserInput('')
        const {
          data: { data, success, errors },
        }: any = await createChatThread(payload, companyId)
        if (success) {
          setResponse(data)
          getAllChatsFromThread()
          setThreadId(data.chatThreadId)
          getAllThreads()
          if (response) {
            setIsBotTyping(false)
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddChatThreadSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                chat_thread_id: data?.chatThreadId,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          setPromptText('')
          errors.forEach((error: string) => {
            if (
              error === errorMessage.UPGRADE_BILLING_PLAN_LIMIT_EXCEEDED ||
              error === errorMessage.UPGRADE_BILLING_PLAN_FEATURE
            ) {
              setShowBillingModal(true)
              toast.error(formatMessage({ id: error }), { autoClose: false })
            } else {
              toast.error(formatMessage({ id: error }))
            }
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddChatThreadFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsBotTyping(false)
    }
  }

  function formatResponseForMarkdown(response: any) {
    return response
      .replace(/([0-9]+)\.\s*/g, '\n\n$1. ')
      .replace(/(\*\*.*?\*\*):\s*/g, '$1:\n\n')
      .replace(/(\n{2,})/g, '\n\n')
      .trim()
  }
  console.log(selectedConversation, ' selectedConversation')

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleUpdateTitle()
    }
  }

  const handleUpdateTitle = async () => {
    setIsRenaming(true)
    try {
      if (companyId) {
        let payload: any = {
          title: newTitle.trim(),
        }
        const {
          data: { success, errors },
        }: any = await updateChatThreadTitle(editingThreadId, payload, companyId)
        if (success) {
          getAllThreads()
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateChatThreadTitleSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: editingThreadId,
                title: payload?.title,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateChatThreadTitleFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: editingThreadId,
                title: payload?.title,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  const deleteChat = async () => {
    setIsDeleting(true)
    try {
      if (companyId) {
        const {
          data: { success, errors },
        }: any = await deleteChatThread(showThread, companyId)
        if (success) {
          getAllThreads()
          setModalOpen(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteChatThreadSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: showThread,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeleteChatThreadFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_id: companyId,
                thread_id: showThread,
                user_id: currentUser?.userId,
                first_name: currentUser?.firstName,
                last_name: currentUser?.lastName,
                email: currentUser?.email,
                error: errors[0],
              }),
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsDeleting(false)
    }
  }
  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
      setEditingThreadId(null)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <div className='d-block gap-4 mb-4 d-md-flex'>
        {/* mobile Menu chat threads */}
        <SideAIChatMenu
          setIsNewConversation={setIsNewConversation}
          setChatsFromThread={setChatsFromThread}
          setThreadId={setThreadId}
          setIsMessageSend={setIsMessageSend}
          chatThreads={chatThreads}
          getAllThreads={getAllThreads}
          setEditThreadId={setEditThreadId}
          editThreadId={editThreadId}
          isTitleRenaming={isTitleRenaming}
          setIsTitleRenaming={setIsTitleRenaming}
        />

        <div className='col-3 d-none d-md-block w-25'>
          <div className='d-flex bg-white rounded-2 p-4 flex-column h-100'>
            <div
              className='flex-grow-1 d-flex flex-column justify-content-end'
              style={{ height: 'calc(100vh - 250px)', overflow: 'hidden' }}
            >
              <button
                className={
                  `btn px-2 py-3 w-100 mb-4 ` +
                  (mode === 'dark'
                    ? `btn-outline-primary btn-no-hover-dark`
                    : `btn-outline-primary btn-hover-primary bg-new-conv-btn btn-no-hover`)
                }
                onClick={() => {
                  setIsNewConversation(true)
                  setChatsFromThread([])
                  handleSelectConversation('')
                  setIsMessageSend(false)
                }}
              >
                <div className='d-flex align-items-center justify-content-center'>
                  <img src={AddChaticon} alt='Add chat icon' />
                  <span className='font-size-13 ms-2'>
                    {formatMessage({ id: 'Start a new Conversation' })}
                  </span>
                </div>
              </button>

              {isShowHelpBanners && (
                <InfoCard2
                  title={formatMessage({ id: 'How Investment Banker AI Can Help?' })}
                  className='mb-0'
                  desc={formatMessage({
                    id: 'Leverage Investment Banker AI to get expert insights, advice, and clarity on your fundraising strategy. Make well-informed decisions and navigate complex investment challenges with ease.',
                  })}
                  slug='https://help.foundercrate.com/en/articles/9799699-maximizing-your-fundraising-strategy-with-investment-banker-ai'
                />
              )}

              <div
                className='d-flex flex-column h-100'
                style={{ overflowY: 'scroll', overflowX: 'hidden' }}
              >
                {isloading ? (
                  <>
                    <div className='mt-4 d-flex flex-column gap-2'>
                      <Skeleton
                        height={40}
                        count={15}
                        className='my-2'
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {sortedThreadDates.map((date: any) => (
                      <div key={date}>
                        <div className='font-size-13 text-dark mt-4 mb-2'>{date}</div>
                        {groupedThreads[date].map((thread: any, index: any) => (
                          <div key={thread.chatThreadId} className={`position-relative`}>
                            <div
                              onClick={() => {
                                handleSelectConversation(thread.chatThreadId)
                                setThreadId(thread.chatThreadId)
                                setIsNewConversation(false)
                              }}
                              className={`d-flex align-items-center p-2 gap-2 cursor-pointer justify-content-between w-100 ${selectedConversation?.trim() === thread.chatThreadId
                                ? mode === 'dark'
                                  ? `selected-class-dark`
                                  : `selected-class`
                                : ''
                                }`}
                              onDoubleClick={() => {
                                setEditingThreadId(thread.chatThreadId)
                                setNewTitle(thread.title)
                              }}
                            >
                              <div
                                className={`d-flex gap-2 align-items-center justify-content-between w-100 ${selectedConversation?.trim() === thread.chatThreadId
                                  ? mode === 'dark'
                                    ? `selected-class-dark`
                                    : `selected-class`
                                  : ''
                                  }`}
                              >
                                <div
                                  className='d-flex align-items-center gap-2'
                                  style={{ maxWidth: '80%' }}
                                >
                                  <img src={Chaticon} alt='Chat icon' />
                                  {editingThreadId === thread.chatThreadId ? (
                                    isRenaming ? (
                                      formatMessage({ id: 'Renaming...' })
                                    ) : (
                                      <div ref={dropdownRef}>
                                        <input
                                          type='text'
                                          className='form-control'
                                          value={newTitle}
                                          onChange={(e) => setNewTitle(e.target.value)}
                                          onKeyDown={(e) => handleKeyDown(e)}
                                          // onBlur={() => setEditingThreadId(null)}
                                          autoFocus
                                        />
                                      </div>
                                    )
                                  ) : (
                                    <ThreadTitle title={thread.title} />
                                  )}
                                </div>
                                <div>
                                  <Dropdown.Toggle
                                    className={
                                      `bi bi-three-dots-vertical p-1 bg-white ` +
                                      (mode === 'dark'
                                        ? `text-white bg-dark btn-active-dark`
                                        : `text-dark btn-active`)
                                    }
                                    style={{ width: '32px', height: '32px' }}
                                    onClick={() => {
                                      setShowKebabMenu((prev) => !prev)
                                      setShowThread(thread.chatThreadId)
                                    }}
                                  ></Dropdown.Toggle>
                                </div>
                                {showKebabMenu && thread.chatThreadId === showThread && (
                                  <div
                                    ref={dropdownRef}
                                    className='card w-100px h-auto shadow rounded kebab-menu-dropdown-adjust cursor-pointer ms-auto'
                                  >
                                    <div
                                      className={
                                        'border-bottom border-gray-300 border-bottom-2 px-4 py-3 ' +
                                        (mode === 'dark'
                                          ? `dropdown-items-color-dark`
                                          : `dropdown-items-color`)
                                      }
                                    >
                                      <div
                                        className='m-0'
                                        onClick={() => {
                                          setEditingThreadId(thread.chatThreadId)
                                          setNewTitle(thread.title)
                                          setShowKebabMenu(!showKebabMenu)
                                        }}
                                      >
                                        {formatMessage({ id: 'Rename' })}
                                      </div>
                                    </div>
                                    <div
                                      className={
                                        'px-4 py-3 ' +
                                        (mode === 'dark'
                                          ? `dropdown-items-color-dark`
                                          : `dropdown-items-color`)
                                      }
                                    >
                                      <div
                                        className='m-0 text-danger'
                                        onClick={() => setModalOpen(true)}
                                      >
                                        {formatMessage({ id: 'Delete' })}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='col-9 w-100 w-md-75'>
          <div className='d-flex bg-white rounded-2 p-4 flex-column'>
            <div
              className='flex-grow-1 d-flex flex-column justify-content-end'
              style={{ height: 'calc(100vh - 250px)', overflow: 'hidden' }}
            >
              {/* Prompt message */}
              <div
                className={`d-flex flex-column justify-content-center align-items-center h-80 ${chatsFromThread.length === 0 ? 'd-block' : 'd-none'
                  }`}
                style={{ marginBlock: 'auto' }}
              >
                {!isMessageSend && (
                  <>
                    <h5 className='text-center mb-4'>
                      {formatMessage({ id: 'Sample questions you can ask me' })}
                    </h5>
                    <div className='d-flex flex-column align-items-center w-100 w-md-50'>
                      {AIBankerQuestions.map((question) => (
                        <button
                          key={question.id}
                          className={
                            `btn btn-lg mb-3 w-100 fw-normal font-size-13 ` +
                            (mode === 'dark' ? `btn-prompt-primary-dark` : `btn-prompt-primary`)
                          }
                          onClick={() => {
                            setUserInput(question.value)
                            setButtonIndex(question.id)
                          }}
                          disabled={buttonIndex === question.id}
                        >
                          {question.value}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
              {/* Chat List */}
              <div
                className='d-flex flex-column gap-2'
                style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}
              >
                {chatsFromThread.map((chat, index) => (
                  <div key={index}>
                    <div className='d-flex gap-2 mb-4 user-parent'>
                      {isloading ? (
                        <Skeleton
                          height={24}
                          width={24}
                          className='my-2'
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <>
                          <DisplayImage
                            imgName={currentUser?.profileImg}
                            alt='User'
                            height='24px'
                            width='24px'
                            fit='contain'
                            className='rounded-circle'
                          />
                        </>
                      )}

                      {isloading ? (
                        <Skeleton
                          height={80}
                          count={1}
                          className='my-2'
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <>
                          <div
                            className={
                              'message mb-0 d-flex flex-column p-2 rounded-2 ' +
                              (mode === 'dark' ? `user-message-dark` : `user-message`)
                            }
                          >
                            <p className='m-0'>{chat.prompt}</p>
                            <p className='font-size-10 text-muted m-0 dateStyle'>
                              {chat.timestamp
                                ? getDateValue(chat.timestamp?.toString())
                                  ? getDateValue(chat.timestamp?.toString())
                                  : DateTime.fromISO(chat.timestamp?.toString()).toLocaleString(
                                    DateTime.DATE_MED
                                  )
                                : '-'}{' '}
                              {chat.timestamp && getTimeZoneValue(chat.timestamp?.toString())}
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                    <div className='d-flex gap-2'>
                      <img
                        src={toAbsoluteUrl('/media/icons/sidebar/v2/ic-ai-banker-active.svg')}
                        alt='Ai'
                        height='24px'
                        width='24px'
                      />

                      {isloading ? (
                        <Skeleton
                          height={80}
                          count={1}
                          className='my-2'
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      ) : (
                        <>
                          <div
                            className={
                              'message mb-0 d-flex flex-column p-2 rounded-2 ' +
                              (mode === 'dark' ? `bot-message-dark` : `bot-message`)
                            }
                          >
                            <p className='m-0'>
                              <ReactMarkdown>
                                {formatResponseForMarkdown(chat.response)}
                              </ReactMarkdown>
                            </p>
                            <p className='font-size-10 text-muted m-0 dateStyle'>
                              {chat.timestamp
                                ? getDateValue(chat.timestamp?.toString())
                                  ? getDateValue(chat.timestamp?.toString())
                                  : DateTime.fromISO(chat.timestamp?.toString()).toLocaleString(
                                    DateTime.DATE_MED
                                  )
                                : '-'}{' '}
                              {chat.timestamp && getTimeZoneValue(chat.timestamp?.toString())}
                            </p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
                {promptText && (
                  <div className='d-flex gap-2 mb-4 user-parent'>
                    <DisplayImage
                      imgName={''}
                      alt='User'
                      height='24px'
                      width='24px'
                      fit='contain'
                      className='rounded-circle'
                    />
                    <div
                      className={
                        'message mb-0 d-flex flex-column p-2 rounded-2 ' +
                        (mode === 'dark' ? `user-message-dark` : `user-message`)
                      }
                    >
                      <p className='m-0'>{promptText}</p>
                      <p className='font-size-10 text-muted m-0 dateStyle min-w-150px'>{'-'}</p>
                    </div>
                  </div>
                )}

                {/* Bot typing indicator */}
                {isBotTyping ? (
                  <div className='d-flex align-items-center gap-2'>
                    <img
                      src={toAbsoluteUrl('/media/icons/sidebar/v2/ic-ai-banker-active.svg')}
                      alt='Ai'
                      height='24px'
                      width='24px'
                    />
                    <TypingAnimation />
                  </div>
                ) : response ? (
                  <div className='d-flex gap-2'>
                    <DisplayImage
                      imgName={AIGenericImage}
                      alt='AI'
                      height='24px'
                      width='24px'
                      fit='contain'
                      className='rounded-circle'
                    />
                    <div
                      className={
                        'message mb-0 d-flex flex-column p-2 rounded-2 ' +
                        (mode === 'dark' ? `bot-message-dark` : `bot-message`)
                      }
                    >
                      <p className='m-0'>{response?.response}</p>
                      <p className='font-size-10 text-muted m-0 dateStyle'>{'-'}</p>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
            {/* Message Input */}
            <div className='mt-6 position-relative'>
              <input
                type='text'
                className='form-control font-size-13 fw-300 ps-4 pe-14 py-4'
                placeholder='Start typing your message here...'
                value={userInput}
                onChange={handleInputChange}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && userInput.length <= 2000) {
                    chatSend()
                  }
                }}
              />
              <button
                type='button'
                className='position-absolute btn btn-transparent p-0 py-1'
                style={{ right: '14px', top: '8px' }}
                onClick={chatSend}
              >
                <img src={Sendicon} alt='Send Message' />
              </button>
              {error && <div className='text-danger font-size-12 mt-1'>{error}</div>}
            </div>
          </div>
        </div>
      </div>
      <DeleteConfirmationModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        deleteChat={deleteChat}
        isDeleting={isDeleting}
      />
    </>
  )
}
